module.exports = __webpack_public_path__ + "static/media/rounded-bottom-desktop.0e28b028.svg";